var map = {
	"./icon-1-area.svg": "LhEy",
	"./icon-1-inhabitant.svg": "9dO+",
	"./icon-2-area.svg": "1yTZ",
	"./icon-2-inhabitant.svg": "033b",
	"./icon-3-area.svg": "uzr4",
	"./icon-3-inhabitant.svg": "2yE+",
	"./icon-4-inhabitant.svg": "JyNI",
	"./icon-appliance-dishwasher.svg": "uEcB",
	"./icon-appliance-dryer.svg": "BF/f",
	"./icon-appliance-washingmachine.svg": "Nv8a",
	"./icon-belgium.svg": "zgge",
	"./icon-calendar-old.svg": "8YPe",
	"./icon-calendar.svg": "Sii8",
	"./icon-cart-dual.svg": "fcVA",
	"./icon-cart-elec.svg": "WDuJ",
	"./icon-cart-gas.svg": "9+Xb",
	"./icon-check-white.svg": "z//l",
	"./icon-check.svg": "ukgX",
	"./icon-close-copy.svg": "Pj4L",
	"./icon-close-white.svg": "fVO0",
	"./icon-close.svg": "LVJs",
	"./icon-cookie.svg": "5PPo",
	"./icon-customer-calendar.svg": "Mr/N",
	"./icon-customer-mail.svg": "BXp7",
	"./icon-customer-name.svg": "uZ0T",
	"./icon-customer-phone.svg": "DDTP",
	"./icon-customer-town.svg": "ElY8",
	"./icon-decrease.svg": "MHMa",
	"./icon-dual.svg": "e9hc",
	"./icon-elec.svg": "C7Cq",
	"./icon-electric-car.svg": "A4tU",
	"./icon-electricity.svg": "LXK8",
	"./icon-form-error.svg": "Q8go",
	"./icon-form-valid.svg": "ZTri",
	"./icon-gas.svg": "Qndk",
	"./icon-heater-elec.svg": "xwMX",
	"./icon-heater-gas.svg": "kuvE",
	"./icon-heater-other.svg": "oU/Y",
	"./icon-heater-pump.svg": "JEhG",
	"./icon-home-battery.svg": "ruSW",
	"./icon-increase.svg": "3bkq",
	"./icon-left.svg": "842O",
	"./icon-loader-spin.svg": "Q9hP",
	"./icon-loader-spin2.svg": "oyS5",
	"./icon-loading.svg": "zCAO",
	"./icon-mono.svg": "BEx9",
	"./icon-night.svg": "NOrm",
	"./icon-notification.svg": "aD+7",
	"./icon-occupation-always.svg": "jArp",
	"./icon-occupation-evening_weekend.svg": "oscR",
	"./icon-occupation-summer.svg": "caXw",
	"./icon-occupation-weekend_holidays.svg": "ngGt",
	"./icon-phone.svg": "0gER",
	"./icon-product-COMFY.svg": "Ds6o",
	"./icon-product-COSY.svg": "0dfB",
	"./icon-product-EASY.svg": "IXzX",
	"./icon-product-Fixed.svg": "36cV",
	"./icon-product-Flex.svg": "EgYr",
	"./icon-product-GROUP.svg": "5pxf",
	"./icon-product-ONLINE.svg": "VN1T",
	"./icon-product-PREPAID.svg": "HDwL",
	"./icon-product-SMART.svg": "WDxM",
	"./icon-product-SUPER.svg": "lB3F",
	"./icon-product-ZEN.svg": "Wo8F",
	"./icon-right.svg": "cUzJ",
	"./icon-services-invoiceModes.svg": "fbFZ",
	"./icon-services-paymentModes.svg": "Y2CM",
	"./icon-services-serviceLevels.svg": "biTb",
	"./icon-situation.svg": "198H",
	"./icon-sp.svg": "PIwe",
	"./icon-step-Contract.svg": "gEHY",
	"./icon-step-Offer.svg": "y7s/",
	"./icon-step-Payment.svg": "eZX3",
	"./icon-step-Situation.svg": "9me3",
	"./icon-step-bg-inactive.svg": "mvvY",
	"./icon-step-bg.svg": "FWbd",
	"./icon-step-done.svg": "TNdr",
	"./icon-step2.svg": "q2gd",
	"./icon-tou.svg": "+Odw",
	"./icon-unoccupied.svg": "UID5",
	"./icon-warning.svg": "67lQ",
	"./icon-water-elec.svg": "5B3Z",
	"./icon-water-gas.svg": "fjPe",
	"./icon-water-other.svg": "D9Kx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Vyzd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ./node_modules/html-loader/dist/cjs.js ^\.\/icon\-.*\.svg$
// module id = Vyzd
// module chunks = 34